import { alpha, darken, lighten, Theme } from "@mui/material";

export const flowTableStyles = (theme: Theme) => {
  const contrast = (color: string) =>
    theme.palette.mode === "dark" ? lighten(color, 0.2) : darken(color, 0.2);

  return `
  .custom-table-wrapper .handsontable td .cell-error-icon.on-list {
    right: 24px;
  }

  .custom-table-wrapper .handsontable td.cell-error .htAutocompleteArrow {
    color: ${contrast(theme.palette.error.main)};
  }

  .ht-status-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    min-height: 24px;
    padding: 2px;
    box-sizing: border-box;
  }

  .ht-status-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    cursor: default;
  }

  .ht-status-icon svg { width: 14px; height: 14px; }

  .ht-status-success {
    color: ${contrast(theme.palette.success.main)};
    background-color: ${alpha(theme.palette.success.main, 0.15)};
  }

  .ht-status-error {
    color: ${contrast(theme.palette.error.main)};
    background-color: ${alpha(theme.palette.error.main, 0.15)};
  }

  .ht-status-null {
    color: ${theme.palette.text.secondary};
    background-color: ${alpha(theme.palette.text.secondary, 0.12)};
    opacity: 0.6;
  }
`;
};
